// extracted by mini-css-extract-plugin
export default {"card":"card_card__GB47t","bookCover":"card_bookCover__9zC+j","bookInfo":"card_bookInfo__QZBX8","title":"card_title__MhiGh"};